export const MAX_DESCRIPTION_LEN = 5000;
export const MAX_TITLE_LEN = 200;
export const MAPYBOX_MIN_DATE = new Date(1970, 0, 1);
export const MAPYBOX_MAX_DATE = new Date(2099, 11, 31);
